import { render } from "./HorizontalPills.vue?vue&type=template&id=0448fcae"
import script from "./HorizontalPills.vue?vue&type=script&lang=js"
export * from "./HorizontalPills.vue?vue&type=script&lang=js"

import "./HorizontalPills.vue?vue&type=style&index=0&id=0448fcae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__